import { useMutation } from "@apollo/client";
import { BookingType } from "api/schema";
import { bookTelephoneBox } from "gql/mutations/booking/createTelephoneBoxBooking";

interface GqlData {
  createBooking: BookingType;
}

interface GqlVars {
  areaId: string;
  start: Date;
  end: Date;
}

export function useCreateTelephoneBox() {
  return useMutation<GqlData, GqlVars>(bookTelephoneBox)[0];
}
